import { C, R } from "@/brand/tokens";

const TONES = {
  white: { background: C.surfaceLight, border: `1px solid ${C.brassLine}`, color: C.textOnLight },
  parchment: { background: C.surfaceLight2, border: `1px solid ${C.brassLine}`, color: C.textOnLight },
  blue: { background: C.surfacePrimary, border: `1px solid ${C.brassLine}`, color: C.textOnDark },
  ink: { background: C.bgDark, border: `1px solid ${C.brassLine}`, color: C.textOnDark },
  glass: { background: "rgba(20,25,32,0.35)", border: `1px solid ${C.brassLine}`, color: C.textOnDark },
};

/**
 * Box6 — the bounded module every content grouping lives inside.
 * Sections stay sharp; boxes carry the radius.
 */
export function Box6({
  as: Tag = "div",
  tone = "white",
  radius = "resource",
  className = "",
  style,
  children,
  ...rest
}) {
  return (
    <Tag
      className={className}
      style={{ ...TONES[tone], borderRadius: R[radius], ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
